// World 11 (Keep) — first post-launch expansion world. Introduces the
// LOCKED TILE mechanic: each board has one locked tile per color, which
// can't slide or merge until a charged tile of matching color lands
// adjacent (see packages/engine/src/merge.ts unlockAdjacentLocks).
// This adds a new strategic layer — "where will the charged tile land?"
// — that W1-W10 didn't have.
//
// Progression: L1-L3 are d=6 openers (4 colors, r=3, tiles=12) that
// introduce the mechanic on a gentle canvas; L4-L10 climb to d=7 with
// branching 12.04 → 20.33. The d=7 ceiling is deliberately held to W4
// Ashwood's band — the new mechanic is its own cognitive load, stacking
// depth on top of novelty would burn players out.
//
// Generator: tools/generate-parallel.mjs --world 11 (180s solver budget,
// lockedPerColor=1 in all 4 configs). Seed 0xaebcc000. 48 candidates
// pooled in ~16346s (~4.5h walltime, 4-worker pool).
import type { LevelDef } from '@tessera/engine';
import { WORLD_11_GENERATED } from './world11-generated';

export const WORLD_11_LEVELS: LevelDef[] = [...WORLD_11_GENERATED];
